<template>
  <li
    :class="[
      'w-full h-120 bg-dustrose text-burgundy p-2.5 lg:w-[calc((100%-3.125rem)/3)]',
      { 'border border-pink': border },
    ]"
  >
    <div class="h-full grid grid-rows-[1fr_max-content] w-full">
      <div class="bg-burgundy overflow-hidden">
        <ResponsiveImage :media="content.image" class="object-cover h-full w-full" />
      </div>
      <div
        :class="[
          'h-max text-center p-5 overflow-hidden',
          { 'border-l border-b border-r border-pink': !border },
        ]"
      >
        <p v-if="content.subtitle" class="uppercase font-title text-pink text-sm mb-2.5">
          {{ content.subtitle }}
        </p>
        <p class="font-title text-2xl mb-2.5 uppercase">{{ content.title }}</p>
        <p>{{ content.description }}</p>
      </div>
    </div>
  </li>
</template>

<script lang="ts">
import type { PropType } from 'vue'

import ResponsiveImage from '@/components/helpers/ResponsiveImage.vue'

export default {
  name: 'ContentCard',
  components: { ResponsiveImage },
  props: {
    border: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object as PropType<ContentCard>,
      required: true,
    },
  },
}
</script>
